import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../Services/axiosConfig";

export default function LinkedInCallback() {
  const navigate = useNavigate();
  const [status, setStatus] = useState<string>("Processing LinkedIn authorization...");
  const hasProcessedRef = useRef(false); // Use ref instead of state

  useEffect(() => {
    // Use ref to persist across re-renders
    if (hasProcessedRef.current) return;
    hasProcessedRef.current = true;

    const processLinkedInCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const state = params.get("state");
      const error = params.get("error");

      if (error) {
        setStatus(`Authorization failed: ${error}`);
        setTimeout(() => navigate("/hr-dashboard"), 3000);
        return;
      }

      if (!code || !state) {
        setStatus("Missing authorization parameters");
        setTimeout(() => navigate("/hr-dashboard"), 3000);
        return;
      }

      const usedKey = `linkedin_code_${code}`;
      if (sessionStorage.getItem(usedKey)) {
        setStatus("LinkedIn authorization already processed.");
        return;
      }
      sessionStorage.setItem(usedKey, "1");

      try {
        setStatus("Sharing job post to LinkedIn...");

        // Add request tracking to prevent duplicates
        const requestId = `linkedin_share_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        
        const response = await api.post("/linkedin/share-job-post", {
          code,
          state,
          requestId // Help backend identify duplicate requests
        });

        if (response.data.success) {
          setStatus("Job successfully shared on LinkedIn!");
          setTimeout(() => navigate("/hr-dashboard"), 2000);
        } else {
          throw new Error(response.data.message || "Failed to share post");
        }
      } catch (err: any) {
        console.error("LinkedIn sharing error:", err);
        
        // Handle specific error cases
        if (err.response?.status === 400) {
          const errorMsg = err.response?.data?.error || '';
          if (errorMsg.includes("already being processed") || errorMsg.includes("duplicate")) {
            setStatus("Request is already being processed. Please wait...");
            setTimeout(() => navigate("/hr-dashboard"), 3000);
            return;
          }
        }
        
        setStatus(err.response?.data?.error || err.message || "Failed to share on LinkedIn");
        setTimeout(() => navigate("/hr-dashboard"), 4000);
      }
    };

    processLinkedInCallback();
  }, [navigate]); // Remove hasProcessed from dependencies

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2>LinkedIn Sharing</h2>
      <p>{status}</p>
      <div>Please wait...</div>
    </div>
  );
}